import { Controller } from "@hotwired/stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  close() {
    this.element.style.display = "none";
    Cookies.set("close_maintenance_message", "true", { expires: 7 });
  }
}
